var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EmoticonListCover"},[_c('div',{staticClass:"EmoticonList"},_vm._l((_vm.EmotionList),function(item,i){return _c('div',{key:i,staticClass:"PicItem",on:{"click":function($event){return _vm.ClickEmoticon(i)}}},[_c('img',{attrs:{"src":'https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/' +
            i +
            '.gif'}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }